import state from './TransferAccount/states'
import mutations from './TransferAccount/mutations'
import actions from './TransferAccount/actions'
import getters from './TransferAccount/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
